import React from 'react';
import { ArrowLeft, Save } from 'lucide-react';
import { Action, Attachments } from '../ui';
import { useProductForm } from './useProductForm';
import { ProductIdentityFields, ProductSupplyFields, ProductPricingFields } from './ProductFields';

export const ProductForm = ({ initial, cancel, saved }) => {
  const model = useProductForm(initial, saved);
  return <form className="product-form" onSubmit={model.submit}>
    <Action secondary id="cancel-product-edit" type="button" onClick={cancel}><ArrowLeft size={15} />Back to catalog</Action>
    <ProductIdentityFields bind={model.bind} />
    <ProductSupplyFields bind={model.bind} specText={model.specText} setSpecText={model.setSpecText} />
    <ProductPricingFields bind={model.bind} tiers={model.form.tiers} updateTier={model.updateTier} />
    <Attachments id="product-document-upload" files={model.files} setFiles={model.setFiles} max={10}
      label="Public technical documents (published with this listing)" />
    {model.error && <div className="notice error" data-testid="product-form-error" role="alert">{model.error}</div>}
    <div className="form-actions"><Action id="save-product" busy={model.busy} type="submit">
      <Save size={16} />{initial.id ? 'Save changes' : 'Publish product'}
    </Action></div>
  </form>;
};